import { dataComponent } from 'dls-icons-data'
import { createIcon } from '../common'

const IconComponent = /*#__PURE__*/createIcon(dataComponent)
export default IconComponent
